/** Small outline icons for the mobile tab bar (24px grid, stroke = currentColor) */
const paths: Record<string, string> = {
  gate: 'M4 20V9l8-5 8 5v11M9 20v-6h6v6M2 20h20',
  students: 'M12 4l9 4-9 4-9-4 9-4zM6 10v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5',
  users: 'M9 11a4 4 0 100-8 4 4 0 000 8zM2 21v-1a6 6 0 0112 0v1M16 3.5a4 4 0 010 7.5M22 21v-1a6 6 0 00-4-5.6',
  messages: 'M4 5h16v11H8l-4 4V5z',
  reports: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  audit: 'M8 6h12M8 12h12M8 18h12M3.5 6h.01M3.5 12h.01M3.5 18h.01',
  settings: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 13.5l1.6 1.2-2 3.5-1.9-.7a7 7 0 01-2 1.2l-.3 2h-4l-.3-2a7 7 0 01-2-1.2l-1.9.7-2-3.5 1.6-1.2a7 7 0 010-3l-1.6-1.2 2-3.5 1.9.7a7 7 0 012-1.2l.3-2h4l.3 2a7 7 0 012 1.2l1.9-.7 2 3.5-1.6 1.2a7 7 0 010 3z',
  account: 'M12 12a4 4 0 100-8 4 4 0 000 8zM4 21a8 8 0 0116 0',
  today: 'M3 10l9-7 9 7v10a1 1 0 01-1 1h-5v-6H9v6H4a1 1 0 01-1-1V10z',
  people: 'M8 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM1.5 20a6.5 6.5 0 0113 0M17 11a3 3 0 100-6M18 14.5a5.5 5.5 0 014.5 5.5',
  changes: 'M4 6h16v14H4zM4 10h16M9 3v4M15 3v4M9 15l2 2 4-4',
  history: 'M12 7v5l3 2M3.5 12a8.5 8.5 0 108.5-8.5A8.5 8.5 0 004.6 8M3 4v4h4',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  scan: 'M4 8V5a1 1 0 011-1h3M16 4h3a1 1 0 011 1v3M20 16v3a1 1 0 01-1 1h-3M8 20H5a1 1 0 01-1-1v-3M7 12h10',
  signout: 'M15 4h4a1 1 0 011 1v14a1 1 0 01-1 1h-4M10 17l5-5-5-5M15 12H3',
};

export function Icon({ name, size = 24 }: { name: keyof typeof paths | string; size?: number }) {
  return (
    <svg className="icon" width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth={name === 'more' ? 3.5 : 1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d={paths[name] ?? paths.more} />
    </svg>
  );
}
